import { uploadEmployeesV2 } from "./upload-employees";
import { updateEmployeesByCsv } from "./update-employees-by-csv";
import parseRowsFromExcel from "../../utils/parseRowsFromExcel";

export async function getCsvEmployees({
  type,
  filename,
  benefitPlan,
  taxRegime,
  company,
}) {
  const uploadData = {
    massiveUpload: async (employees) => {
      try {
        return await uploadEmployeesV2({
          company,
          taxRegime,
          benefitPlanId: benefitPlan,
          employees: employees.map((employee) =>
            Object.keys(employee).reduce(
              (acc, curr) =>
                curr === "grossSalary"
                  ? { ...acc, [curr]: Number(employee[curr]) }
                  : { ...acc, [curr]: String(employee[curr]) },
              {}
            )
          ),
        });
      } catch (err) {
        return undefined;
      }
    },
    massiveEdit: async (employees) => {
      try {
        return await updateEmployeesByCsv({ employees });
      } catch (err) {
        return undefined;
      }
    },
  };

  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve) => {
    const parsedEmployees = await parseRowsFromExcel(type, filename);
    await uploadData[type](parsedEmployees);
    resolve(parsedEmployees);
  });
}
